import React, { useEffect, useRef } from "react";

export function useOutsideAlerter(
  ref: React.RefObject<HTMLElement>,
  onClickOutside: () => void
) {
  // Store the callback in a ref to avoid effect re-runs
  const callbackRef = useRef(onClickOutside);

  // Update the ref when callback changes
  useEffect(() => {
    callbackRef.current = onClickOutside;
  }, [onClickOutside]);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (
        ref.current &&
        event.target instanceof Node &&
        !ref.current.contains(event.target)
      ) {
        callbackRef.current();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}
